import text_blur_input from "@/views/add_text/modules/text_blur_input";

export default (context) => {
    window.addEventListener("orientationchange", () => {
        context.text_blur_input(context)
    }, false);

    context.popup.value = true
    context.overlay = true

    if(context.editeableItem) {
        if(context.editeableItem.descr) {
            context.text = context.editeableItem.descr
        }
    }

    context.maxSymbol = context.maxSymbolComputed


    context.video.mp4 = context.mp4
    context.video.webm = context.webm

    const checkElement = () => {
        let el = document.getElementById('player-component')

        if(el) {
            el.style.opacity = 1
        } else {
            setTimeout(() => {
                checkElement()
            }, 50);
        }
    }

    checkElement()


    context.$nextTick(() => {
        context.rendering = true
    })
}